/**
 * 多标签页兼容守卫
 * 当前 jobId 已由 URL 独立承载，允许同一浏览器中打开多个任务标签页。
 * 保留原有导出 API，避免外部调用方需要改造。
 */

class SingleTabGuard {
    /**
     * 启动标签页守卫
     * 多标签模式下不需要注册活跃标签，也不关闭其他标签页。
     */
    start(): void {
        // no-op
    }

    /**
     * 停止标签页守卫
     */
    stop(): void {
        // no-op
    }

    /**
     * 当前标签页是否活跃
     * 多标签模式下每个标签页都视为可用。
     */
    isActiveTab(): boolean {
        return true;
    }

    /**
     * 更新全局更新时间戳（保留占位，避免外部调用方报错）
     */
    updateGlobalTimestamp(): void {
        // no-op
    }
}

// 导出单例
export const singleTabGuard = new SingleTabGuard();
